import { useState, useEffect, Fragment, useMemo, } from 'react';
import { useTranslation } from 'react-i18next'
import { DateTime } from "luxon";
import Grid from '@toast-ui/react-grid';

// Grid.applyTheme('striped');

// import Loader from '~components/Loader/Loader';

import { useHookStore } from '../../hook-store/store';

import classes from './UsageBasedBilling.module.css';


function UsageTable(props) {

  const {
    startTime,
    endTime,
    usageList,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [dayDataList, setDayDataList] = useState([]);

  // console.log(usageBasedPrice, usageBasedSubscription)
  
  useEffect(() => {
    if (startTime > 0 && endTime > 0 && usageList.length > 0) {
      createDayArray(
        startTime*1000,
        endTime*1000,
      );
    }
  },[startTime, endTime, usageList]);


  const createDayArray = (startTs, endTs) => {

    // const adElId = adPlaceId && adPlaceId !== 'all' ? adPlaceId : '';
    
    const nowDateElements = new Date().toISOString().split('T')[0].split('-');
    const nowYear = parseInt(nowDateElements[0]);
    const nowMonth = parseInt(nowDateElements[1]);
    const nowDay = parseInt(nowDateElements[2]);
    const dayArray = [];

    let dayDuration = 750;

    // console.log('startTs, endTs', startTs, endTs);

    for (let i=0; i<dayDuration; i++) {
      const time = DateTime.local(nowYear, nowMonth, nowDay).plus({ days: -i })
      const timePlusDay = DateTime.local(nowYear, nowMonth, nowDay).plus({ days: -(i-1) })
      const name = DateTime.local(nowYear, nowMonth, nowDay).plus({ days: -i }).toISODate();
      // console.log(
      //   time,
      //   new Date(time.ts),
      //   new Date(timePlusDay.ts),
      //   name,
      // )

      if (time.ts >= startTs && timePlusDay.ts <= endTs) {
        dayArray.push({
          name: name,
          start: time.ts,
          end: timePlusDay.ts,
          uList: [],
          valueSum: 0,
        });
      }
    }

    // console.log('dayArray', dayArray);


    const listForAddObj = usageList.find(usage => {
        return usage.start === startTs && usage.end === endTs; 
    });

    if (listForAddObj) {
      for (const usage of listForAddObj.data) {
        const dayData = dayArray.find(ele => {
          return ele.start <= usage.start_time*1000 &&
             ele.end >= usage.end_time*1000;
        });
        // console.log('match-day', dayData, usage);
  
        if (dayData) {
          dayData.uList.push(usage);
          dayData.valueSum += usage.aggregated_value; 
        }
      }
  
    }

    // console.log('dayArray', dayArray);
    setDayDataList(dayArray);

    return dayArray;
  };

  // console.log(usageList);

  let tuiGData = [
    // {id: 1, name: 'Editor'},
    // {id: 2, name: 'Grid'},
    // {id: 3, name: 'Chart'}
  ];

  const columns = [
    { name: 'name', header: 'Date' },
    { name: 'valueSum', header: 'Unit' },
    { name: 'usdValue', header: 'USD value' },
  ];


  // tuiGData = dayDataList.map(ele => {
  //   return {
  //     ...ele,
  //     id: ele.name,
  //   }
  // })


  let displayList;

  displayList = usageList.find(usage => {
    return usage.start === startTime*1000 && usage.end === endTime*1000; 
  });

  if (displayList) {
    displayList = displayList.data;
    // tuiGData = dayDataList.map(ele => {
    //   return {
    //     ...ele,
    //     id: ele.name,
    //   }
    // })
  }

  // console.log('tuiGData', tuiGData);

  let periodTotal = 0;
  let periodTotalUSD = 0;

  if (usageBasedPrice && displayList) {
    // const priceUnit = usageBasedPrice.unit_amount;
    const priceUnit = Number(usageBasedPrice.unit_amount_decimal);

    for (const usage of displayList) {
      periodTotal = periodTotal + Number(usage.aggregated_value);
    }

    periodTotalUSD = priceUnit/100*periodTotal;

    tuiGData = dayDataList.map(ele => {
      return {
        ...ele,
        id: ele.name,
        usdValue: ele.valueSum *  priceUnit/100,
      }
    })

  }

  let tuiGridBody = useMemo(() => {
      return (
        <Grid
          data={tuiGData}
          columns={columns}
          rowHeight={20}
          bodyHeight={400}
          heightResizable={true}
          // rowHeaders={['rowNum']}
          pageOptions={{
            useClient: true,
            perPage: 50
          }}
          scrollY={true}
          scrollX={true}
        />
      )
    }, [dayDataList])

  let usageTableBody;

  if (usageBasedPrice && usageBasedSubscription && displayList && tuiGData.length > 0) {
    usageTableBody = (
      <div>
        <div className={classes.usageBasedBillingRow}>
          Total: {periodTotal} ({periodTotalUSD.toFixed(2)} USD)
        </div>

        <div className={classes.usageBasedBillingRow}>
          {tuiGridBody}
        </div>
        {/* <Grid
          data={tuiGData}
          columns={columns}
          rowHeight={20}
          bodyHeight={400}
          heightResizable={true}
          // rowHeaders={['rowNum']}
          pageOptions={{
            useClient: true,
            perPage: 20
          }}
          scrollY={true}
          scrollX={true}
        /> */}

      </div>
    )
  }





  return (
    <Fragment>
      <div>{usageTableBody}</div>
    </Fragment>
  );
}

export default UsageTable;
